import React, { useEffect, useState } from 'react'

import {
  TableBodyStyled,
  TableCellStyled,
  TableStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableFooter,
  TableRowStyled,
  Span
} from 'components'
import { COLORS, TYPOGRAPHY } from 'utils'

interface ITableData {
  nuAnoMesCompetencia: string
  statusMovimentacao: string
  isCompetenciaAtual: boolean
}

export interface ITableMovPesquisaFornecedor {
  tableData: ITableData[]
  handleClickComp: (_comp: string) => void
}

const TableMovPesquisaFornecedor: React.FC<ITableMovPesquisaFornecedor> = ({
  tableData,
  handleClickComp
}) => {
  const collator = new Intl.Collator([], { numeric: true })

  const [data, setData] = useState<ITableData[]>(tableData ?? [])
  const [page, setPage] = useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)

  const handleChangePage = (newPage: number) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const reverseCompetencia = (str: string) => {
    return str.split('/').reverse().join('')
  }

  useEffect(() => {
    setData((prevState) =>
      prevState.sort((a, b) =>
        collator.compare(
          reverseCompetencia(b.nuAnoMesCompetencia),
          reverseCompetencia(a.nuAnoMesCompetencia)
        )
      )
    )
  }, [])

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left">
                Competências Anteriores
              </TableCellStyled>
              <TableCellStyled align="left">Status Mobilização</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {data?.length === 0 ? (
              <TableRowStyled>
                <TableCellStyled align="center">
                  <Span
                    text="Não há competências anteriores cadastradas para este contrato"
                    color={COLORS.black}
                    fontSize={TYPOGRAPHY.bodySize16}
                  />
                </TableCellStyled>
              </TableRowStyled>
            ) : (
              (rowsPerPage > 0
                ? data.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : data
              )?.map((row: ITableData) => (
                <TableRowStyled
                  key={row?.nuAnoMesCompetencia}
                  onClick={() => handleClickComp(row?.nuAnoMesCompetencia)}
                >
                  <TableCellStyled align="left">
                    {row?.nuAnoMesCompetencia}
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {row?.statusMovimentacao}
                  </TableCellStyled>
                </TableRowStyled>
              ))
            )}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        rows={tableData}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
    </>
  )
}

export default TableMovPesquisaFornecedor
